<template>
    <div>
        <div class="p-5 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-lg" role="alert">
            <span class="font-bold text-xl"><i class="fas fa-exclamation-triangle mr-1"></i> {{$t('mes_produits.paiement.une_action_est_requise_de_votre_part')}}</span>
            <p>{{$t('mes_produits.paiement.proceder_au_paiement')}}</p>

            <hr class="my-5 border-yellow-800">

            <div class="text-xl font-bold mb-5">{{$t('mes_produits.paiement.montant_a_payer')}}: {{amount}}€</div>


            <template v-if="errors && errors.length > 0">
                <h6 class="text-red-600">Erreurs</h6>
                <template v-for="(error, index) in errors">
                    <div class="text-red-600" :key="'error-' + index">
                        <small> {{error.message}} </small>
                    </div>
                </template>
                <hr class="my-3">
            </template>
            <div class="flex flex-wrap">
                <sav-input class="mb-3 w-full" :label="$t('mes_produits.paiement.nom_sur_la_carte')" type="text" v-model="name" />
                <sav-input class="mb-3 w-full" :label="$t('mes_produits.paiement.numero_de_carte')" type="text" v-model="number" />
                <div class="grid grid-cols-2 gap-3 w-full mb-3">
                    <sav-input :label="$t('mes_produits.paiement.mois')" type="select" v-model="month" :options="{ label: 'value', values: [ {value: '01'}, {value: '02'}, {value: '03'}, {value: '04'}, {value: '05'}, {value: '06'}, {value: '07'}, {value: '08'}, {value: '09'}, {value: '10'}, {value: '11'}, {value: '12'}] }" />
                    <sav-input :label="$t('mes_produits.paiement.annee')" type="select" v-model="year" :options="{ label: 'value', values: cardYears }" />
                </div>
                <sav-input class="w-full" :label="$t('mes_produits.paiement.cvv')" type="text" v-model="cvv" />
                <div class="my-5" v-if="loading">
                    <sav-spinner :size="10" />
                </div>
                <button v-if="!loading" :disabled="loading" @click="pay" class="mt-3 text-white bg-green-500 hover:bg-green-600 duration-200 px-3 py-2.5 text-sm font-light border-red-200 rounded">
                    <i class="fas fa-check mr-1"></i> {{$t('mes_produits.paiement.valider')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import eventHub from '@/eventHub'

export default {
    props: {
        idCase: {required: true},
    },
    data() {
        return {
            amountData: null,
            amount: null,
            name: null,
            number: null,
            month: null,
            year: null,
            cvv: null,
            cardYears: [],
            errors: [],
            loading: false
        }
    },

    methods: {
        async init() {
            this.createCardyearsValues()

            let responseAmount = await apiService.post('get_amount', {
                id_case: this.idCase
            })
            this.amountData = responseAmount.data.posts.post
            this.amount = this.amountData.montant_total
            if (this.amountData.montant_total == this.amountData.montant_already_paid) {
                this.endAction()
            }
        },

        async pay() {
            if (this.amount != null && this.number != null && this.name != null && this.month != null && this.year != null && this.cvv != null) {
                this.loading = true
                let response = await apiService.post('pay', {
                    montant: this.amount,
                    card_name: this.name,
                    card_number: this.number,
                    card_month: this.month.value,
                    card_year: this.year.value,
                    card_cvv: this.cvv,
                    id_conso: this.$crypto.decrypt(localStorage.getItem('client_id')),
                    id_case: this.idCase
                })
                this.errors = []

                if (response.data.posts.error) {
                    this.errors.push({
                        message: response.data.posts.error
                    })
                } else {
                    this.endAction()
                }
                this.loading = false
            } else {
                this.errors.push({
                    message: this.$t('mes_produits.paiement.merci_de_remplir_tous_les_champs')
                })
            }
        },

        endAction() {
            this.$toast.success(this.$t('mes_produits.paiement.paiement_valide'))
            eventHub.$emit('refresh-product')
        },

        createCardyearsValues() {
            let currentYear = new Date().getFullYear()
            for (let i = 0; i < 9; i++) {
                this.cardYears.push({value: i + currentYear}) 
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/user/product/FolderActions.vue/PayFormAction.vue